module.exports = __webpack_public_path__ + "img/gou-green.1c80dc7a.svg";